var exports = {
  "tooltip": "x8b4e8595--099c37--tooltip",
  "success": "x8b4e8595--099c37--success",
  "error": "x8b4e8595--099c37--error",
  "tooltip-visible": "x8b4e8595--099c37--tooltip-visible",
  "tooltip-dissolve-in": "x8b4e8595--099c37--tooltip-dissolve-in",
  "tooltip-hidden": "x8b4e8595--099c37--tooltip-hidden",
  "tooltip-dissolve-out": "x8b4e8595--099c37--tooltip-dissolve-out",
  "message": "x8b4e8595--099c37--message",
  "favorites-link": "x8b4e8595--099c37--favorites-link",
  "button": "x8b4e8595--099c37--button",
};

module.exports = exports;
